import { render } from "./SubmitClaim.vue?vue&type=template&id=f66bba52"
import script from "./SubmitClaim.vue?vue&type=script&lang=js"
export * from "./SubmitClaim.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__